/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import GeneratedLettersPresenter from './GeneratedLettersPresenter';

function GeneratedLettersController() {
  return <GeneratedLettersPresenter />;
}

export default GeneratedLettersController;
